module.exports = __webpack_public_path__ + "img/34ne.6dbeab40.svg";